import type {
  Iso3166Alpha3Lower,
  LocaleCode,
  LocaleDefinition,
} from "../types";

import { deriveLocaleMetadata } from "../country/derive-locale-metadata";

function findLocaleCodeFromIso3166Alpha3Lower(
  iso3166Alpha3Lower: Iso3166Alpha3Lower,
  definitions: LocaleDefinition[],
): LocaleCode | null {
  for (const definition of definitions) {
    const metadata = deriveLocaleMetadata(definition.code);

    if (metadata.country.iso3166Alpha3Lower !== iso3166Alpha3Lower) {
      continue;
    }

    return definition.code;
  }

  return null;
}

export { findLocaleCodeFromIso3166Alpha3Lower };
